type ShouldRedirectCalendarOAuthCallbackToDesktopArgs = {
  isDesktop: boolean;
  returnedState: string | null;
  storedState: string | null;
};

/**
 * Detects provider callbacks that landed in web after starting from desktop.
 *
 * Desktop starts calendar OAuth with an HTTPS redirect URI that providers can
 * accept, then the web callback page bounces the provider result back through
 * the `mem://` protocol. Web-owned callbacks must keep processing locally, so
 * a matching web localStorage state wins. Missing or mismatched web state means
 * the current browser tab does not own this callback.
 */
export const shouldRedirectCalendarOAuthCallbackToDesktop = ({
  isDesktop,
  returnedState,
  storedState,
}: ShouldRedirectCalendarOAuthCallbackToDesktopArgs): boolean => {
  return !isDesktop && !!returnedState && storedState !== returnedState;
};
